import React from "react";
import { Div, Image, Text, Icon } from "atomize";

import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

const CaseStudyCardMobile = ({ content, ...rest }) => {
  return (
    <a href={`/case-study/${content.node.slug}`} target="_blank">
      <Div
        p="2rem 0"
        border={{ b: "1px solid" }}
        borderColor="border"
        d="flex"
        justify="space-between"
        align="flex-start"
      >
        <Div p={{ r: "1.5rem" }} textColor="white">
          <Text
            textSize="tiny"
            textWeight="700"
            m={{ b: "0.5rem" }}
            style={{ letterSpacing: "1.5px" }}
          >
            CASE STUDY
          </Text>
          <Text textSize="paragraph" textWeight="700">
            “{content.node.title}”
          </Text>
        </Div>
        <Div
          h="5rem"
          w="5rem"
          minW="5rem"
          bg={content.node.color || "blueGray"}
          d="flex"
          align="center"
          justify="center"
        >
          <ImageLink link={content.node.companyLogo.description}>
            <Image src={content.node.companyLogo.file.url} h="2rem" w="auto" />
          </ImageLink>
        </Div>
      </Div>
    </a>
  );
};

export default CaseStudyCardMobile;
